module.exports = __webpack_public_path__ + "img/circle-active.38db24a6.svg";